<svelte:options
  customElement={{
    tag: 'teo-tabs',
    extend: extendWithStyles,
  }}
/>

<script lang="ts" module>
  import type { TeoCore } from '@/teoCore/TeoCore';
  import Tabs from '@/ui/components/tabs/Tabs.svelte';
  import { TeoContextProvider } from '@/utils/teo-context';

  import { extendWithStyles } from './web-component-utils';
</script>

<script lang="ts">
  let { teoCore }: { teoCore: TeoCore } = $props();
</script>

<TeoContextProvider {teoCore}>
  <Tabs />
</TeoContextProvider>
